import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import {
    Col, Row, Form, FormGroup, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import { mountTable, unmountTable, refreshSelected, getTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';
import ModalAsignarTutor from "../Components/ModalAsignarTutor";
import AssignSelectPanel from "../Components/AssignSelectPanel";

const dataTable = {
  headerRow: ["Convocatoria", "Proyecto", "Estado", "Situación", "Responsable", "Sector", "Tutor", "Acciones"],
  footerRow: ["Convocatoria", "Proyecto", "Estado", "Situación", "Responsable", "Sector", "Tutor", "Acciones"]
};

class PreIncubationTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      showShare: false,
      multipleSelect: null,
      convocatoriaFiltro: {value: this.props.convocatorias[0], label: this.props.convocatorias[0]},
      estadoFiltro: {value: 4, label: 'PRE-INCUBACION'},
    };
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickCheckbox = this.onClickCheckbox.bind(this);
    this.onClick = this.onClick.bind(this);
    this.confirm = this.confirm.bind(this);
    this.confirmArchive = this.confirmArchive.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.assignProject = this.assignProject.bind(this);
    this.customAction = [
      this.props.currentRole === 'Coordinador' && {
        htmlString: '<input class="checkbox" type="checkbox"></input>',
        actionString: 'change',
        actionFunction: this.onClickCheckbox,
      }
    ];
    this.filters = [{name: 'estado', value:'estadoFiltroPreIncubation'}, {name: 'convocatoria', value:'convocatoriaFiltroPreIncubation'}];
  }

  componentDidMount() {
    mountTable(API_ROOT + "/incubation/ideas", "preIncubationTab", this.onClickEdit, null, this.customAction, true, 8, this.filters);
  }
  componentWillUnmount() {
    unmountTable('preIncubationTab');
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.convocatorias !== nextProps.convocatorias) {
      this.setState({convocatoriaFiltro: {value: nextProps.convocatorias[0], label: nextProps.convocatorias[0]}});
    }
  }
  shouldComponentUpdate() {
    return true;
  }
  onClickCheckbox(data, selected) {
    this.setState({ selectedRows: selected });
  }
  onClickEdit(data) {
    this.props.history.push("/incubation/" + data[8] +'/pre-incubation');
  }
  onClick() {
    this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Incubar proyectos?"
          onConfirm={() => this.confirm(this.state.selectedRows)}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Desea incubar los proyectos seleccionados?`}
          <p>Total Seleccionados: {this.state.selectedRows.length}</p>
        </SweetAlert>
      );
  }
  confirm(idsProyectos) {
    refreshSelected();
    this.props.incubate(idsProyectos);
    this.setState({ selectedRows: [] });
  }
  confirmArchive(idsProyectos) {
    refreshSelected();
    this.props.archive(idsProyectos);
    this.setState({ selectedRows: [] });
  }
  applyFilters() {
    this.setState({ selectedRows: [] });
    refreshSelected();
    const table = getTable('preIncubationTab');
    table.clear();
    table.ajax.reload();
    table.draw();
  }
  assignProject() {
    this.props.assignProject(
      'preIncubationTab',
      this.state.selectedRows,
      this.state.multipleSelect,
      () => this.setState({showShare: false, multipleSelect: null, selectedRows: [] })
    );
  }
  render() {
    const estadosList = [];
    this.props.estados.forEach((item) => {
      estadosList.push({value: item.id, label: item.nombre});
    });
    const convocatoriasList = [];
    this.props.convocatorias.forEach((item) => {
      convocatoriasList.push({value: item, label: item});
    })
    return(
      <div>
        <Form horizontal>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                  Convocatoria:
                </Col>
                <Col md={6}>
                  <Select
                    placeholder="Seleccione"
                    closeOnSelect={true}
                    name="type"
                    value={this.state.convocatoriaFiltro}
                    options={convocatoriasList}
                    onChange={(value) => { this.setState({convocatoriaFiltro: value}, this.applyFilters)}}
                  />
                </Col>
              </FormGroup>
            </Col>
            {this.props.currentRole === 'Coordinador' &&
              <Col md={8}>
                <AssignSelectPanel
                  onClickAssign={() => this.setState({ showShare: true })}
                  assignDisabled={this.state.selectedRows.length === 0}
                  onClickSelect={this.onClick}
                  selectDisabled={this.state.selectedRows.length === 0}
                  selectButtonLabel={'Incubar Proyectos'}
                  onClickArchive={this.onClickArchive}
                  archiveButtonLabel={'Enviar a INACTIVO'}
                />
              </Col>
            }
          </Row>
        </Form>
        <input style={{display: 'none'}} type="text" className="estadoFiltroPreIncubation" value={JSON.stringify(this.state.estadoFiltro)} disabled />
        <input style={{display: 'none'}} type="text" className="convocatoriaFiltroPreIncubation" value={JSON.stringify(this.state.convocatoriaFiltro)} disabled />
        <div className="fresh-datatables">
          <JQueryTableComponent dataTable={dataTable} identifier="preIncubationTab" />
        </div>
        <ModalAsignarTutor
          showModal={this.state.showShare}
          onHideModal={() => this.setState({showShare: false})}
          selectValue={this.state.multipleSelect}
          selectOptions={this.props.users}
          selectOnChange={(value) => { this.setState({ multipleSelect: value})}}
          onClickCancel={() => this.setState({showShare: false})}
          onClickAccept={this.assignProject}
          acceptDisabled={!this.state.multipleSelect}
        />
      </div>
    );
  }
}

export default PreIncubationTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreIncubationTab.jsx